export interface IDisplayTextProps {text: string}

const DisplayText: React.FC<IDisplayTextProps> = ({text}) => {
    return <div className={"standardText"}>{text}</div>
}

export default DisplayText;